import { PlansData } from "../data/plans";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { addToCart } from "../services/plansSlice";
import { Countdown, SuggestedCourses } from "../components";
import { StyledLink } from "../utils/button";
import "../styles/plans.css";

interface plans {
  plansData: {
    id: number;
    frequency: string;
    price: string;
    type: string;
    show: number;
    title: string;
    details: string;
    remark: string;
  };
}

const Plans = () => {
  const dispatch = useDispatch();
  const handleAddToCart = (plan: plans["plansData"]) => {
    dispatch(addToCart(plan));
  };
  const plans = PlansData.map((plan, i) => (
    <div key={i}>
      <h4>{plan.type}</h4>
      <p>{plan.remark}</p>
      <p>{plan.price}</p>
      <p>{plan.frequency}</p>
      <StyledLink
        to="/cart"
        onClick={() => {
          handleAddToCart(plan);
        }}
      >
        Get Started
      </StyledLink>
    </div>
  ));

  return (
    <>
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0.4 }}
        transition={{ duration: 0.5 }}
        className="plans"
      >
        <section className="plans-container">
          <div className="plans-content">
            <h1>Offer Ends Soon!</h1>
            <p>
              Subscribe to have access to unlimited videos with our flexible
              payment palns
            </p>
            <Countdown />
          </div>
          <div className="plans-showcase">{plans}</div>
        </section>
      </motion.main>
      <SuggestedCourses heading="On Demand Courses" />
    </>
  );
};

export default Plans;
